import React, { useContext } from "react";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationModuleLabelField from "./CertificationModuleLabelField";

const CertificationModuleFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { moduleText } = entity as CertificationInterface;

  return <CertificationModuleLabelField {...{ module: moduleText }} />;
};

export default React.memo(CertificationModuleFieldContainer);
